<p>Kindly select any of the banks below</p>
<section class="banks flexed">
  @for (bank of banks; track bank) {
    <div class="bank" (click)="makePayment(bank.value)">
      <div class="img_wrapper">
        <img src="{{ bank.logo }}" alt="" />
      </div>
      <p class="no-margin-b ml-3">{{ bank.name }}</p>
    </div>
  }
</section>
<div class="footer" style="text-align: center; font-size: 8px">
  <app-footer
    [whiteLabelInfo]="whiteLabelInfo()"
    style="margin-top: 14rem"
  ></app-footer>
</div>

<app-error-dialog
  [visible]="showModal"
  [message]="errorMessage"
  (closed)="showModal = false"
/>
